import React from 'react'
import { styled } from '@material-ui/core/styles'
import { Paragraph } from '../../components/paragraph/Paragraph'
import photo from './bethany-optimised.jpg'

const Photo = styled('img')(({ theme: { spacing } }) => ({
  float: 'left',
  margin: `${spacing(0.5)}px ${spacing(2)}px ${spacing()}px ${spacing(0.25)}px`,
  width: 192,
  height: 270,
}))

export function Home() {
  return (
    <React.Fragment>
      <Photo src={photo} alt="Bethany" />
      <Paragraph>
        Buongiorno and Hello!
      </Paragraph>
      <Paragraph>
        My name is Bethany, and I am an Italian>English translator, subtitler, consecutive interpreter, transcriptionist, editor and proof-reader, specialising in the following fields:
      </Paragraph>
      <Paragraph>
        Art; Banking; Business and Commerce; Certificates; Communications; Cosmetics; Entertainment; Fashion; Film; Gastronomy; Health Services; Hospitality; Humanities; Human rights; Journalism; Literature; ‘Light’ legal texts (such as Privacy Policies and Terms & Conditions); Marketing; Media; Social Care; Theatre; Tourism, and Transport.
      </Paragraph>
      <Paragraph>
        I graduated with a First Class BA (Hons) degree in English and Italian from Royal Holloway, University of London, where I received four academic prizes and a Mark of Distinction in the Italian oral exam. During my degree I received both theoretical and practical training from professional and literary translators, as well as an in-depth education in the literature, art, society, politics and history of both Anglo and Italian cultures.
      </Paragraph>
      <Paragraph>
        I am also a qualified Public Service Interpreter, having achieved a Level 3 Certificate in Community Interpreting with the International School of Linguists, specialising in Social Care and Healthcare.
      </Paragraph>
      <Paragraph>
        I currently work as a freelancer with Italian, US and UK agencies, and I have also completed a year of internships for language service companies in Italy, where I developed a mature experience not only in translation, but in summarising and localising books and articles; writing and editing English course modules; compiling and maintaining glossaries for clients; preparing material for conferences; swearing in translations in court; Desktop Publishing; writing and marking English tests; creating phrasebooks for children; writing blog posts on language learning and translation; and translating/localising the agencies' websites.
      </Paragraph>
      <Paragraph>
        I strive to produce fluid, consistent and accurate translations, working with various Computer Assisted Translation tools to enhance my working capacity. I am a native English speaker and read copiously in both Italian and English in order to maintain a broad vocabulary and remain sensitive to various registers.
      </Paragraph>
      <Paragraph>
        In my free time I seek to continue refining and cultivating my linguistic skills, and have translated booklets and posters for a friend running art exhibitions in Emilia Romagna and New York, edited novels and regularly proofread essays, website material and documents for acquaintances. I have also translated Italian literature for my own interest, such as parts of Italo Calvino’s <em>Invisible Cities</em>.
      </Paragraph>
    </React.Fragment>
  )
}
